/* =========================================================
   EASTEAM — behaviour fixes, 2026-08-08
   1. Mobile menu: one tap to the collections, sub-groups collapsed
   2. Gift card PDP: a Checkout button beside Add to Cart
   ========================================================= */
(function () {
  'use strict';

  var MOBILE = '(max-width: 991px)';
  function isMobile() { return window.matchMedia(MOBILE).matches; }

  /* =======================================================
     1. MOBILE MENU

     Theme markup:
       .menu-wrapper > ul.navbar-sidebar
         > li.navbar__item.dropdown                  ← level 1 (DAYDREAM 2.0, SHOP)
             > div.navbar__link.menu-dropdwon
             > div.inner-navbar
                 > .inner-navbar__innerbox
                     > .inner-navbar__title          (back arrow)
                     > ul > li.dropdown              ← level 2 (This Season, By Occasion…)
                              > .grand-inner-navbar
                                  > ul > li > a       ← the actual collections

     DAYDREAM 2.0's level-2 groups ("This Season", "Archive") are just buckets,
     so they are dissolved and the four seasons list directly — one tap, done.
     SHOP's groups (By Occasion / By Category / By Collection) are real, separate
     axes, so they stay as collapsed rows you can open one at a time.
     ======================================================= */

  /* top-level items whose level-2 groups are only labels, not categories */
  var DISSOLVE = ['daydream 2.0'];

  function topPanel(li) { return li.querySelector(':scope > .inner-navbar'); }
  function subPanel(li) { return li.querySelector(':scope > .grand-inner-navbar'); }

  /* scrollHeight reads 0 while an ancestor is collapsed, so lift the cap for a
     frame, measure, and put it back. */
  function measure(panel) {
    var prev = panel.style.maxHeight;
    panel.style.transition = 'none';
    panel.style.maxHeight = 'none';
    var h = panel.scrollHeight;
    panel.style.maxHeight = prev;
    void panel.offsetHeight;
    panel.style.transition = '';
    return h;
  }

  /* after the animation, drop the cap so nothing can be clipped and the drawer
     scrolls the full list */
  function uncapWhenDone(li, panel) {
    var done = function (e) {
      if (e && e.propertyName && e.propertyName !== 'max-height') return;
      if (li.classList.contains('et-open')) panel.style.maxHeight = 'none';
      panel.removeEventListener('transitionend', done);
    };
    panel.addEventListener('transitionend', done);
    setTimeout(done, 480);
  }

  function closeItem(li) {
    li.classList.remove('et-open');
    var p = topPanel(li) || subPanel(li);
    if (p) p.style.maxHeight = '0px';
  }

  function openItem(li) {
    li.classList.add('et-open');
    var p = topPanel(li) || subPanel(li);
    if (!p) return;
    var h = measure(p);
    p.style.maxHeight = (h > 0 ? h + 40 : 1600) + 'px';
    uncapWhenDone(li, p);
  }

  /* lift a group's children into the list above it, then drop the empty group */
  function dissolveGroups(panel) {
    var ul = panel.querySelector('ul');
    if (!ul) return;
    Array.prototype.slice.call(ul.children).forEach(function (group) {
      if (group.tagName !== 'LI' || !group.classList.contains('dropdown')) return;
      var inner = subPanel(group);
      var innerUl = inner && inner.querySelector('ul');
      if (!innerUl) return;
      Array.prototype.slice.call(innerUl.children).forEach(function (child) {
        if (child.tagName === 'LI') ul.insertBefore(child, group);
      });
      ul.removeChild(group);
    });
  }

  function prepareMenu() {
    var wrap = document.querySelector('.menu-wrapper');
    if (!wrap || wrap.__etAccordion) return;
    var sidebar = wrap.querySelector('ul.navbar-sidebar');
    if (!sidebar) return;
    wrap.__etAccordion = true;
    wrap.classList.add('et-accordion');

    Array.prototype.slice.call(sidebar.children).forEach(function (li) {
      if (li.tagName !== 'LI' || !li.classList.contains('dropdown')) return;
      var panel = topPanel(li);
      if (!panel) return;

      li.classList.add('et-parent');
      panel.style.maxHeight = '0px';

      var label = (li.querySelector(':scope > .navbar__link') || {}).textContent || '';
      if (DISSOLVE.indexOf(label.trim().toLowerCase()) !== -1) {
        dissolveGroups(panel);
        return;
      }

      /* everything else keeps its groups, collapsed */
      Array.prototype.slice.call(panel.querySelectorAll('li.dropdown')).forEach(function (group) {
        var inner = subPanel(group);
        if (!inner) return;
        group.classList.add('et-sub');
        inner.style.maxHeight = '0px';
      });
    });
  }

  /* Capture phase, so the theme's own drill-down handler never runs. */
  document.addEventListener('click', function (e) {
    if (!isMobile()) return;
    var label = e.target.closest && e.target.closest('.menu-wrapper .navbar__link.menu-dropdwon');
    if (!label) return;
    var li = label.parentElement;
    if (!li) return;
    if (!li.classList.contains('et-parent') && !li.classList.contains('et-sub')) return;

    e.preventDefault();
    e.stopPropagation();

    if (li.classList.contains('et-open')) { closeItem(li); return; }
    /* one open branch per level keeps the drawer short */
    Array.prototype.slice.call(li.parentElement.children).forEach(function (sib) {
      if (sib !== li && sib.classList && sib.classList.contains('et-open')) closeItem(sib);
    });
    openItem(li);
  }, true);

  /* =======================================================
     2. GIFT CARD PDP — Checkout as well as Add to Cart

     Shopify's accelerated checkout buttons can't be used here because they skip
     the gift-card recipient fields. So post the form to /cart/add.js (which
     understands the properties[…] inputs, recipient email and message
     included) and then go straight to checkout.
     ======================================================= */
  function addGiftCardCheckout() {
    if (!document.body.classList.contains('template-suffix-gift-card')) return;
    var actions = document.querySelector('.product-actions');
    var form = document.querySelector('form[action*="/cart/add"], .main-product-form');
    if (!actions || !form || actions.querySelector('.et-gc-checkout')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'et-gc-checkout';
    btn.textContent = 'Checkout';
    actions.appendChild(btn);

    btn.addEventListener('click', function () {
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

      var label = btn.textContent;
      btn.textContent = 'Taking you to checkout…';
      btn.disabled = true;

      var fd = new FormData(form);
      fd.append('__shopify_offset', String(new Date().getTimezoneOffset()));
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add the gift card.');
            window.location.href = root + 'checkout';
          });
        })
        .catch(function (err) {
          btn.textContent = label;
          btn.disabled = false;
          alert(err.message);
        });
    });
  }

  function boot() {
    if (isMobile()) prepareMenu();
    addGiftCardCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* the drawer is built lazily on first open; the pre-order app also re-renders
     the buy block after load, which can drop the button */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.navbar-toggler, [data-mobile-hamburger]')) {
      setTimeout(boot, 60);
      setTimeout(boot, 400);
    }
  });
  setTimeout(addGiftCardCheckout, 900);
  setTimeout(addGiftCardCheckout, 2200);
  window.addEventListener('resize', function () { setTimeout(boot, 150); });
})();
